import Vue from 'vue'
import { Store } from 'vuex'
import Component from 'vue-class-component'
import RootState from '../../store/state'
import PreviewVue from './Preview.vue'
import { Actions, Mutations } from '../../store/editor/components/helpers'
import * as CommonHelper from '../../store/common/helpers'
import { isNotFound } from '../../misc/get-status-code'

// 記事IDをバインドされた値（componentId）または vue-router のパラメータ（content_id）から受け取り、
// その記事をプレビューする画面。

@Component({
  components: {
    'preview-vue': PreviewVue
  },
  props: {
    contentId: {
      type: Number,
      required: false
    }
  }
})
export default class PreviewPageVue extends Vue {
  $store: Store<RootState>
  readonly contentId?: number
  isLoading: boolean = false

  get kajikiId(): number {
    return parseInt(this.$route.params['kajiki_id'], 10)
  }

  get contentIdFromParam(): number | undefined {
    const contentId = this.$route.params['content_id']
    return contentId ? parseInt(contentId, 10) : undefined
  }

  get actualContentId(): number | undefined {
    return this.contentId || this.contentIdFromParam
  }

  mounted(): void {
    if (!this.actualContentId) {
      throw new Error('記事IDが指定されていないため、プレビューできません。')
    }

    // 記事データを読み込む
    Mutations.initializeContent(this.$store, this.kajikiId)
    this.isLoading = true
    Actions.loadContent(this.$store, {
      siteId: this.kajikiId,
      contentId: this.actualContentId
    }).then((content) => {
      this.isLoading = false
    }).catch((reason) => {
      if (isNotFound(reason)) {
        CommonHelper.Mutations.setErrorStatus(this.$store, 'not-found')
        this.isLoading = false
        return
      }
      this.isLoading = false
      CommonHelper.Actions.addNotification(this.$store, {
        type: 'preview__loading-failed',
        level: 'warning',
        message: '記事情報の読み込みに失敗しました。通信環境をご確認のうえ、再度お試しください。'
      })
    })
  }

  back(): void {
    this.$router.go(-1)
  }
}
